import { render, staticRenderFns } from "./StructureErrorsModal.vue?vue&type=template&id=39f1e865&"
import script from "./StructureErrorsModal.vue?vue&type=script&lang=ts&"
export * from "./StructureErrorsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports